import React from 'react';
export function PerformanceFlagRow({ icon, title, description, lastOccurrence, buildings }) {
    return (React.createElement("div", { className: "performance-flag-row" },
        React.createElement("div", { className: "performance-flag-row__bar" }),
        React.createElement("div", { className: "performance-flag-row__body" },
            React.createElement("div", { className: "performance-flag-row__header" },
                React.createElement("i", { className: `fa-light ${icon}` }),
                React.createElement("span", { className: "performance-flag-row__title" }, title)),
            React.createElement("p", { className: "performance-flag-row__description" }, description),
            (lastOccurrence || (buildings && buildings.length > 0)) && (React.createElement("div", { className: "performance-flag-row__info" },
                lastOccurrence && (React.createElement(React.Fragment, null,
                    React.createElement("i", { className: "fa-light fa-calendar-day" }),
                    React.createElement("span", null,
                        "Last occurrence: ",
                        lastOccurrence))),
                lastOccurrence && buildings && buildings.length > 0 && React.createElement("span", { className: "performance-flag-row__dot" }),
                buildings && buildings.length > 0 && (React.createElement("span", null,
                    "Buildings: ",
                    buildings.slice(0, 3).join(', '),
                    buildings.length > 3 ? ` +${buildings.length - 3} more` : '')))))));
}
